<template>
    <div class="backgroud-white cs-courseSchedule-editor" v-loading="isSaving">
        <div class="backgroud-gray-popup popup-content-area-small">
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item prop="UniversityId" label="付款备注：" label-width="100px" class="label-strong">
                  <el-input type="textarea" rows="3" placeholder="" v-model="form.comment" class="input-width"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col :span="20" :xs="16" class="footer-left">
                    <span v-if="!showError"></span>
                    <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                </el-col>
                <el-col class="footer-right" :span="4" :xs="8">
                    <el-button :disabled="isSaving" :type="submitBtnClass" @click="save()">确认修改</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import {
  savePaymentComment
} from "../../service/finance.service";

export default {
  name: "paymentCommentEditor",
  props: {
    dataIn:{
      accountPaymentId: Number,
      comment: String,
    }
  },
  data() {

    return {
      isSaving: false,
      showError: false,
      errorMessage: "",
      submitBtnClass: "primary",
      form: {
        comment: "",
      },
      rules: {
      }
    };
  },
  created() {
    this.init(); 
  },
  watch:{
    dataIn:function(){
      this.init();
    }
  },
  methods: {
    init(){
      if (this.dataIn){
        this.form.comment = this.dataIn.comment;
      }else{
        this.form.comment = "";
      }
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
        this.submitBtnClass = "primary";
      });
      if (isValid) {
        this.submitBtnClass = "primary";
      } else {
        this.submitBtnClass = "info";
      }
    },
    async save() {
      let valid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          valid = false;
        }
      });
      if (!valid) return;
      this.isSaving = true;
      
      let result = await savePaymentComment(this.dataIn.accountPaymentId, this.form.comment);
      if (result) {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.showError = false;
          this.$refs.form.resetFields();
          this.$emit("success", {
            accountPaymentId: this.dataIn.accountPaymentId, 
            comment: this.form.comment
          });
        }
      }
      this.isSaving = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/finance/paymentCommentEditor.vue